export const en = {
  "sending.message": "Sending...",
  "send.message.failed": "Failed to send message",
};
